import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
} from "@angular/core";
import { MatDialogConfig, MatDialog } from "@angular/material/dialog";
import { AddressComponent } from "src/app/components/dialogs/client-address/address/address.component";
import { DeleteaddressComponent } from "src/app/components/dialogs/client-address/deleteaddress/deleteaddress.component";
import { MediaObserver } from "@angular/flex-layout";
import { ClientaddressesService } from "src/app/services/apiclient/clientaddresses/clientaddresses.service";
import { ToolsService } from "src/app/services/tools/tools.service";
import { PanierService } from "src/app/services/manage/panier/panier.service";
import { DialogsService } from "src/app/services/manage/dialogs/dialogs.service";
import { MondialRelayComponent } from "src/app/components/dialogs/mondial-relay/mondial-relay.component";
import {CssService} from "../../../../services/css-service";
import {SalemethodService} from "../../../../services/api/salemethod/salemethod.service";


@Component({
  selector: "app-addresses-endorder",
  templateUrl: "./addresses-endorder.component.html",
  styleUrls: ["./addresses-endorder.component.css"],
})
export class AddressesEndorderComponent implements OnInit {

  @Input()
  clientAddresses$: any;

  @Input()
  type: string | any;

  @Input()
  error: string | any;

  @Output()
  toggleCagnotteEvent = new EventEmitter<any>();

  @Output()
  setIsRelayEvent = new EventEmitter<boolean>();

  @Output()
  setSelectedRelayEvent = new EventEmitter<boolean>();

  // RESPONSIVE
  respCols: any = {
    xs: 1,
    sm: 2,
    md: 2,
    lg: 2,
    xl: 3,
  };

  currSM: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
  currPOS: any = this.tools.getStor("point_of_sale");

  currAddress$: any;

  shippingModes: any;
  selectedShippingMode: any;

  showList: boolean | any;
  loader: boolean = true;

  currCols: number = this.media.isActive("xs") ? 1 : 2;
  rowHeight: number =
    this.media.isActive("xs") ||
      this.media.isActive("sm") ||
      this.media.isActive("md")
      ? 150
      : 200;

  /**
   * Relay
   */
  selectedRelay: any;
  displaytitle: any;
  constructor(
    private tools: ToolsService,
    private media: MediaObserver,
    private dialog: MatDialog,
    private panMan: PanierService,
    public cssService: CssService,
    private addressApi: ClientaddressesService,
    public myDials: DialogsService
  ) {
    this.media.asObservable().subscribe((media: any) => {
      this.currCols = this.respCols[media.mqAlias];
    });
  }

  ngOnInit() {

    this.displaytitleShippingMode();
    // this.tools.setOnPopState();
    this.getAddress();
    this.panMan.getPanier.subscribe((basket) => {
      if (basket && this.currAddress$ && this.currSM.enable_shipping_cost > 0) {
        this.initShippingModes(this.currAddress$);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes["clientAddresses$"] && changes["clientAddresses$"].currentValue) {
      this.loader = false;
    }

    if (changes["error"] && changes["error"].currentValue) {
      if (changes["error"].currentValue === "relayneeded"
        || changes["error"].currentValue === "delivryaddress"
        || changes["error"].currentValue === "billingaddress") {
        this.tools.scrollTo("delivryaddress");
      }
    }
  }

  /**
   * @description Récupère l'observable adresse
   * @returns {void}
   */
  getAddress(): void {

    if (this.type === "delivry") {
      this.addressApi.getDelivryAddress.subscribe((address) => {
        if (address) {
          if (this.currSM.enable_shipping_cost > 0) {
            this.initShippingModes(address);
          }


        }
        this.currAddress$ = address;
      });
    } else if (this.type === "billing") {
      this.addressApi.getBillingAddress.subscribe((address) => {
        this.currAddress$ = address;

      });
    }
  }

  /**
   * @description Sélectionne une adresse
   * @param {any} address
   * @returns {void}
   */
  selectAddress(address: any): void {
    if (this.type === "billing") {
      this.addressApi.setBillingAddress(address);
    } else if (this.type === "delivry") {
      this.addressApi.setDelivryAddress(address);
      this.displaytitleShippingMode();
    }
    setTimeout(() => {
      this.currAddress$ = address;
      this.setShowList(false);
    });
  }

  isInCountry(shippingMode: any): boolean {
    if (this.currAddress$ == null) {
      return true;
    }
    for (let i = 0; i < shippingMode.countries.length; i++) {
      if (shippingMode.countries[i].id == this.currAddress$.id_country) {


        return true;
      }
    }

    return false;


  }


  /**
   * @description displaytitleShippingMode
   *
   */
  displaytitleShippingMode() {
    if (this.shippingModes) {
      let flag = false;
      if (this.currAddress$ == null) {
        flag = true;
      }

      for (let index = 0; index < this.shippingModes.length; index++) {

        const element = this.shippingModes[index];
        for (let i = 0; i < element.countries.length; i++) {
          const ele = element.countries[i];
          if (ele.id == this.currAddress$.id_country) {
            flag = true;
            break
          }
        }

      }
      this.displaytitle = flag;
    }
    else {
      this.displaytitle = true;
    }

  }


  /**
   * @description Selectionne le mode d'expedition
   * @param cost
   */
  selectShippingMode(shippingMode: any): void {

    this.currAddress$.shipping_mode = shippingMode;
    this.selectedShippingMode = shippingMode;
    this.selectAddress(this.currAddress$);
    this.setIsRelay(shippingMode.is_relay > 0 ? true : false);
    this.toggleCagnotteEvent.emit(true);
    // Ouverture de la popup Mondial Relay
    if (shippingMode.is_relay > 0) {
      this.openMondialRelayDial();
    }
  }

  /**
   * @description Ajoute les prix sur les modes d'expedition en fonction de l'adresse
   * @param {any} address
   * @returns {void}
   */
  initShippingModes(address: any): void {
    const basketWeight = this.panMan.getWeight();
    const basketPrice = this.panMan.getPrice();

    /**
     * On ajoute le prix au mode d'expedition et on regarde si le poids dépasse ou non
     */
    this.currPOS.shipping_costs.map((mode: any) => {
      for (let i = 0; i < mode.costs.length; i++) {
        let ship = mode.costs[i];

        /**
         * On vérifie le poids
         */
        if (mode.costs[mode.costs.length - 1].max_weight < basketWeight) {
          mode.to_much_weight = mode.costs[mode.costs.length - 1].max_weight;
        } else {
          mode.to_much_weight = null;
        }

        /**
         * On vérifie l'offert
         */
        if (mode.offered_from && basketPrice > mode.offered_from) {
          mode.price = 0;
          break;

          /**
           * On set le prix
           */
        } else if (basketWeight <= ship.max_weight) {
          mode.price = ship.shipping_price;
          break;
        }
      }
    });


    this.shippingModes = this.currPOS.shipping_costs;


    /**
     * On set le mode d'expedition de l'adresse par defaut
     */

    if (!address.shipping_mode) {
      for (let i = 0; i < this.shippingModes.length; i++) {
        if (this.shippingModes[i].is_relay < 1) {
          address.shipping_mode = this.shippingModes[i];
          break;
        }
      }
    }
  }

  // DIALS

  /**
   * @description Ouvre la dialog de création d'adresse
   * @param {any} address
   * @returns {void}
   */
  openDialAddress(): void {


    if (!this.loader) {

      const myConf = new MatDialogConfig();
      myConf.autoFocus = false;
      myConf.data = {
        address: this.currAddress$,
        clientAddresses: this.clientAddresses$,
        type: this.type,
      };

      this.media.isActive("xs")
        ? (myConf.width = "100%", myConf.height = "100%")
        : (myConf.width = "550px", myConf.minHeight = "500px");

      const myDial = this.dialog.open(AddressComponent, myConf);
      //changed
      this.tools.setOnPopState(true);

      myDial.afterClosed().subscribe((data) => {
        if (data) {
          // this.setAddresses(data.address);
          this.selectAddress(data.address);

        }

      });
    }
  }

  /**
   * @description Ouvre la dialog de suppression d'adresse
   * @param {number} addressId
   * @returns {void}
   */
  openDialDeletAddress(addressId: any): void {

    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      addressId: addressId,
      from: this.type,
    };

    const myDial = this.dialog.open(DeleteaddressComponent, myConf);

    myDial.afterClosed().subscribe((data) => {
      if (data) {
        this.currAddress$ = data.address;
      }
    });
  }

  /**
   * @description Set les adresses dans l'observable
   * @param {any[]} addresses
   */
  setAddresses(addresses: boolean): void {
    this.addressApi.setAddresses(addresses);
  }

  /**
   * @description Set le flag d'affichage de la liste des adresses
   * @param {boolean} value
   * @returns {void}
   */
  setShowList(value: boolean): void {
    this.showList = value;
  }

  /**
   * @description Retourne tous les modes d'expedition qui ne sont pas associés à mondial relay
   * @returns {any}
   */
  filterShippingMode(): any {
    return this.shippingModes.filter((x: any) => x.is_relay < 1);
  }

  /**
   * @description Check si un string contient le substring renseigné
   * @params {string} baseString
   * @params {string} checkString
   */
  stringContain(baseString: string, checkString: string): boolean {
    return (baseString.toLowerCase().indexOf(checkString) < 0) ? false : true;
  }

  /**
   * Relay
   */

  /**
   * @description Cette fonction change la valeur de isRelay sur le composant parent (endorderComponent)
   * @param newVal
   */
  setIsRelay(newVal: boolean): void {
    this.setIsRelayEvent.emit(newVal);
  }

  /**
 * @description Cette fonction change la valeur de isRelay sur le composant parent (endorderComponent)
 * @param newVal
 */
  setSelectedRelay(relay: any): void {
    this.selectedRelay = relay;
    this.setSelectedRelayEvent.emit(relay);
  }


  /**
   * @description Ouvre la popup des choix de point de relais mondial relay
   * @returns {void}
   */
  openMondialRelayDial(relay?: any): void {

    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = { relay: relay, delivryAddress: this.currAddress$ };
    this.media.isActive("xs")
      ? (myConf.panelClass = "full-w")
      : (myConf.width = "700px");
    const myDial = this.dialog.open(MondialRelayComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
      if (result) {
        this.setSelectedRelay(result);
      }
    });
  }

}
